<script lang="ts" setup>
import { mdiCalendar } from "@mdi/js";
import { toRefs } from "vue";
import { VDateInput } from "vuetify/labs/components";

import { type FieldInputProps, useFormInput } from "./use-form-input";

interface DateFieldProps extends FieldInputProps {}

const props = withDefaults(defineProps<DateFieldProps>(), {
  disabled: false,
  hint: "",
  label: undefined,
});

const { disabled, error, field } = useFormInput(toRefs(props));
const { value: formValue, handleBlur, handleChange } = field;
</script>

<template>
  <VDateInput
    v-bind="$attrs"
    :disabled="disabled || props.disabled"
    :error="!!error"
    :hint="error ?? hint"
    :label="label"
    :model-value="formValue"
    prepend-icon=""
    :prepend-inner-icon="mdiCalendar"
    @blur="handleBlur"
    @update:model-value="handleChange"
  />
</template>
